@if (dataSignal().img && dataSignal().img !== null) {
<a class="cursor-pointer" tabindex="0" [routerLink]="[`/${ROUTER_TOKENS.PROMOTIONS}/detail`, dataSignal().id]">
  <figure>
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title"
      [title]="dataSignal().title"
      class="item-image"
      loading="lazy"
    />
    <figcaption>
      @switch (headingLevel) { @case ('h3') {
      <h3 class="font-size-36 font-weight-bold line-clamp-2">{{ dataSignal().title }}</h3>
      } @default {
      <h2 class="font-size-36 font-weight-bold line-clamp-2">{{ dataSignal().title }}</h2>
      } }
      <p class="font-size-24 font-weight-regular line-clamp-4">
        {{ dataSignal().excerpt }}
      </p>
    </figcaption>
  </figure>
</a>
} @else {
<div class="item-image"></div>
}
